"use strict"; // Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _classCallCheck = require("/codebuild/output/src237558920/src/pavilions-web-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src237558920/src/pavilions-web-app/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkFlow = void 0;

var preact_1 = require("preact");

var rxjs_1 = require("rxjs");

var TryExtensionLinkDialog_1 = require("./TryExtensionLinkDialog");

var LinkFlow = /*#__PURE__*/function () {
  function LinkFlow(options) {
    _classCallCheck(this, LinkFlow);

    this.extensionUI$ = new rxjs_1.BehaviorSubject({});
    this.subscriptions = new rxjs_1.Subscription();
    this.isConnected = false;
    this.isOpen = false;
    this.onCancel = null;
    this.root = null; // if true, hide QR code in LinkFlow (which happens if no jsonRpcUrl is provided)

    this.connectDisabled = false;
    this.darkMode = options.darkMode;
    this.version = options.version;
    this.sessionId = options.sessionId;
    this.sessionSecret = options.sessionSecret;
    this.linkAPIUrl = options.linkAPIUrl;
    this.isParentConnection = options.isParentConnection;
    this.connected$ = options.connected$;
  }

  _createClass(LinkFlow, [{
    key: "attach",
    value: function attach(el) {
      var _this = this;

      this.root = document.createElement("div");
      this.root.className = "-cbwsdk-link-flow-root";
      el.appendChild(this.root);
      this.render();
      this.subscriptions.add(this.connected$.subscribe(function (v) {
        if (_this.isConnected !== v) {
          _this.isConnected = v;

          _this.render();
        }
      }));
    }
  }, {
    key: "detach",
    value: function detach() {
      var _a;

      if (!this.root) {
        return;
      }

      this.subscriptions.unsubscribe();
      (0, preact_1.render)(null, this.root);
      (_a = this.root.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(this.root);
    }
  }, {
    key: "setConnectDisabled",
    value: function setConnectDisabled(connectDisabled) {
      this.connectDisabled = connectDisabled;
    }
  }, {
    key: "open",
    value: function open(options) {
      this.isOpen = true;
      this.onCancel = options.onCancel;
      this.render();
    }
  }, {
    key: "close",
    value: function close() {
      this.isOpen = false;
      this.onCancel = null;
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.root) {
        return;
      }

      var subscription = this.extensionUI$.subscribe(function () {
        if (!_this2.root) {
          return;
        }

        (0, preact_1.render)((0, preact_1.h)(TryExtensionLinkDialog_1.TryExtensionLinkDialog, {
          darkMode: _this2.darkMode,
          version: _this2.version,
          sessionId: _this2.sessionId,
          sessionSecret: _this2.sessionSecret,
          linkAPIUrl: _this2.linkAPIUrl,
          isOpen: _this2.isOpen,
          isConnected: _this2.isConnected,
          isParentConnection: _this2.isParentConnection,
          onCancel: _this2.onCancel,
          connectDisabled: _this2.connectDisabled
        }), _this2.root);
      });
      this.subscriptions.add(subscription);
    }
  }]);

  return LinkFlow;
}();

exports.LinkFlow = LinkFlow;